import React, { useState, useEffect } from "react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import './CloneProject.css'; // New CSS file

const CloneProject = ({ user, treeData, onClose, onNewProject }) => {
  const [selectedProjectToken, setSelectedProjectToken] = useState(null);
  const [newProjectName, setNewProjectName] = useState('');
  const [newProjectToken, setNewProjectToken] = useState('');
  const [newProjectCode, setNewProjectCode] = useState('');
  const [submissionFormName, setSubmissionFormName] = useState('');
  const [submissionFormToken, setSubmissionFormToken] = useState('');
  const [reviewFormName, setReviewFormName] = useState('');
  const [reviewFormToken, setReviewFormToken] = useState('');

  const handleProjectSelect = (projectToken) => {
    setSelectedProjectToken(projectToken);
  };

  useEffect(() => {
    console.log("treeData:", treeData);

    setSelectedProjectToken(null); // Reset selected project token when treeData changes
    setNewProjectName('Test Project 2025');
    setNewProjectToken('PPPPPP'); 
    setNewProjectCode('TEST2025');
    setSubmissionFormName('Test project submissions');
    setSubmissionFormToken('SSSSSS'); 
    setReviewFormName('Test project reviews');
    setReviewFormToken('RRRRRR');

  }, [treeData]);
  

  const handleCloneSubmit = () => {
    if ( !selectedProjectToken || !newProjectName || !newProjectToken || !newProjectCode ||
      !submissionFormName || !submissionFormToken || !reviewFormName || !reviewFormToken ) {
      alert("Please fill in all fields.");
      return;
    }
    // Placeholder: Later, insert clone logic here
    console.log("Clone project from:", selectedProjectToken);
    console.log("New project name:", newProjectName);
    console.log("New project token:", newProjectToken);
    console.log("New project code:", newProjectCode);
    console.log("Submission form name:", submissionFormName);
    console.log("Submission form token:", submissionFormToken);
    console.log("Review form name:", reviewFormName);
    console.log("Review form token:", reviewFormToken);

    onNewProject({
      sourceProjectToken: selectedProjectToken,
      newProject: {
        name: newProjectName,
        token: newProjectToken,
        code: newProjectCode
      },
      submissionForm: {
        name: submissionFormName,
        token: submissionFormToken
      },
      reviewForm: {
        name: reviewFormName,
        token: reviewFormToken
      }
    });

    onClose();
  };

  const buildTree = () => {
    if (!Array.isArray(treeData)) return null;

    if (treeData.length > 0 && treeData[0]?.projects !== undefined) {
      // Multi-account mode
      return treeData.map(account => (
        <TreeItem
          key={account.value}
          itemId={account.value}
          label={
            <span className="clone-tree-label">
              <WebStoriesIcon className="clone-tree-icon" />
              {account.label}
            </span>
          }
          className="clone-tree-account"
        >
          {(account.projects ?? []).map(project => (
            <TreeItem
              key={project.value}
              itemId={project.value}
              label={
                <span className={`clone-tree-label ${selectedProjectToken === project.value ? 'selected' : ''}`}>
                  <WebStoriesIcon className="clone-tree-icon" />
                  {project.label}
                </span>
              }
              onClick={() => handleProjectSelect(project.value)}
              className="clone-tree-project"
            />
          ))}
        </TreeItem>
      ));
    } else {
      // Single account mode
      return treeData.map(project => (
        <TreeItem
          key={project.value}
          itemId={project.value}
          label={
            <span className={`clone-tree-label ${selectedProjectToken === project.value ? 'selected' : ''}`}>
              <WebStoriesIcon className="clone-tree-icon" />
              {project.label}
            </span>
          }
          onClick={() => handleProjectSelect(project.value)}
          className="clone-tree-project"
        />
      ));
    }
  };

  return (
    <div className="clone-project-container">
      <h3>Clone Existing Project</h3>
      
      <div className="clone-project-tree">
        <SimpleTreeView>
          {buildTree()}
        </SimpleTreeView>
      </div>

      <div className="clone-project-form">
        <input
          type="text"
          placeholder="New Project Name"
          value={newProjectName}
          onChange={(e) => setNewProjectName(e.target.value)}
          className="clone-project-input"
        />
        <input
          type="text"
          placeholder="New Project Token"
          value={newProjectToken}
          onChange={(e) => setNewProjectToken(e.target.value)}
          className="clone-project-input"
        />
        <input
          type="text"
          placeholder="New Project Code"
          value={newProjectCode}
          onChange={(e) => setNewProjectCode(e.target.value)}
          className="clone-project-input"
        />
        <input
          className="clone-project-input"
          placeholder="Submission Form Name"
          value={submissionFormName}
          onChange={(e) => setSubmissionFormName(e.target.value)}
        />

        <input
          className="clone-project-input"
          placeholder="Submission Form Token"
          value={submissionFormToken}
          onChange={(e) => setSubmissionFormToken(e.target.value)}
        />

        <input
          className="clone-project-input"
          placeholder="Review Form Name"
          value={reviewFormName}
          onChange={(e) => setReviewFormName(e.target.value)}
        />

        <input
          className="clone-project-input"
          placeholder="Review Form Token"
          value={reviewFormToken}
          onChange={(e) => setReviewFormToken(e.target.value)}
        />
        <div className="clone-project-button-row">
          <button
            onClick={handleCloneSubmit}
            className="clone-project-button"
          >
            Clone Project
          </button>

          <div className="button-close" onClick={onClose}>
            &times;
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneProject;
